// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2R1j4","label":"LabeledBox_label__2fJVM"};